export const tierlevel = {
    title: 'สิทธิพิเศษระดับขั้นวอปเปอร์',
    sub_title: 'สะสมอีกคราวพอยท์ เพื่อให้อยู่ในสิทธิระดับขั้นวอปเปอร์ที่กำหนดไว้',
    tabs_level:[
        {lv: 'ซิลเวอร์'},
        {lv: 'โกลด์'},
        {lv: 'แพลทินัม'},
        {lv: 'ไดมอนด์'},
    ],
    level_name:[
        // {lv: 'ซิลเวอร์'},
        {lv: 'โกลด์'},
        {lv: 'แพลทินัม'},
        {lv: 'ไดมอนด์'},
        {lv: ''},
    ],
    benefit_title: 'Benefits',
    condition_title: 'Conditions',
}
